$('.tego-displaycheckable').displaycheckable();
